import { Injectable } from '@angular/core';
import { Helper, ProjectsFacade, abbreviateCountryStr } from '@piqet-angular/data';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  DISTANCE_KM_LABEL,
  grid_widths_map,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { NumericCellEditor } from 'libs/ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { cloneDeep } from 'lodash';
import { Subject, take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ProjectPackMaterialListDataGridService {
  copyPackMaterial = new Subject<[any, any, any]>();
  copyPackMaterialData$ = this.copyPackMaterial.asObservable();

  deletePackMaterial = new Subject<[any]>();
  deletePackMaterialData$ = this.deletePackMaterial.asObservable();

  updateBookMark = new Subject<[any]>();
  updateBookMark$ = this.updateBookMark.asObservable();

  event: any;
  projectPackMaterialDataPayload: any;
  projectPackConversionProcessDataPayload: any;
  projectPackCustomTransportPayload: any;

  inlineEditing = new Subject<any>();
  inlineEditingObservable$ = this.inlineEditing.asObservable();

  editFillingSuccess = new Subject<any>();
  editFillingSuccessData$ = this.editFillingSuccess.asObservable();

  areaHideShowCheck = new Subject();
  areaHideShowCheckSuccessData$ = this.areaHideShowCheck.asObservable();

  editProjectMaterialSub = new Subject<[any, any]>();
  editProjectMaterialSubData$ = this.editProjectMaterialSub.asObservable();

  editProjectMaterialManualDistanceSub = new Subject<any>();
  editProjectMaterialManualDistanceSubData$ =
    this.editProjectMaterialManualDistanceSub.asObservable();

  saveProjectManualDistance = new Subject<[any, any]>();
  saveProjectManualDistanceData$ = this.saveProjectManualDistance.asObservable();

  clearInputFieldProjectManualDistance = new Subject<any>();
  clearInputFieldProjectManualDistance$ = this.clearInputFieldProjectManualDistance.asObservable();

  checkDeleteRow = new Subject<[any, any, boolean]>();
  checkDeleteRowData$ = this.checkDeleteRow.asObservable();
  allTransportLocationRecords: any;

  constructor(
    private projectsFacade: ProjectsFacade,
    private swalService: SwalService,
    private toaster: ToastrService,
    private accessService: AccessPermissionService
  ) {}
  getPackMaterialProjectListsDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: '',
        headerName: '',
        field: '',
        rowDrag: true,
        cellClass: 'scenarioDragIcon',
        minWidth: grid_widths_map.icon_md,
        maxWidth: grid_widths_map.icon_md,
        resizable: false,
      });
    colDef.push({
      ...defaultColumn,
      colId: '',
      headerName: '',
      field: '',
      cellClass: 'my-permission-cursor-pointer center-content-cell',
      maxWidth: grid_widths_map.icon_md,
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      autoHeaderHeight: true,
      wrapHeaderText: true,
      cellRenderer: 'bookmarkRenderer',
      cellRendererParams: {
        updateBookmark: (params: any) => {
          this.updateBookMark.next(params);
        },
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Component name',
      field: 'name',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      cellStyle: { 'text-decoration': 'underline' },
      lockVisible: false,
      resizable: false,
      wrapHeaderText: true,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          this.projectsFacade.openNewAddProjectMaterial(
            params.data.scenarioId,
            params.data.componentId,
            'Review component details',
            true,
            'material-list'
          );
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'PackageLevelInfoName',
      headerName: 'Packaging levels',
      field: 'packageLevelInfoName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialWeight',
      headerName: 'Weight of component (grams)',
      field: 'materialWeight',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      autoHeaderHeight: true,
      wrapHeaderText: true,
      editable: this.accessPermission(),
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'MaterialWeight') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellRenderer: (params: any) => {
        return (
          '<span class="editable-icon editable-icon-padding-conversion">' +
          params.value +
          '<i class="fa fa-pencil icon-opacity" aria-hidden="true"></i></span>'
        );
      },
      cellEditorParams: {
        from: 'project-pages-inline',
        allowZero: 'true',
      },
      cellClass: ['outerGridEdit', 'outerGridProjectEdit', 'elipsisFields'],
      valueSetter: (params: any) => {
        const valueChanged = params.data[params.colDef.field] !== params.newValue;
        const oldValue = params.data[params.colDef.field];
        const newVal = params.newValue == 0 ? oldValue : params.newValue;
        if (params.newValue == 0) return;
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        const field = params.colDef.field;
        const nodeId = params.data.id;
        const inlineObject = {
          entityId: 'componentId',
          entityIdValue: params.data['componentId'],
          entityColumnName: params.colDef.field,
          filter: 'agTextColumnFilter',
          entityColumnValue: params.data[params.colDef.field],
        };
        if (!this.isEmpty(newVal) && valueChanged) {
          this.inlineEditing.next(inlineObject);
          return valueChanged;
        } else {
          this.toaster.error('Component name is required');
          return oldValue;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialName',
      headerName: 'Material',
      field: 'materialName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RecycledContent',
      headerName: 'Recycled content (%)',
      field: 'recycledContent',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      wrapHeaderText: true,
      cellRenderer: (params: any) => {
        return `<div class="truncated-text">${
          !params.data?.isCustomMaterial ? params.value : 'N/A'
        }</div>`;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'CountryName',
      headerName: 'Country',
      field: 'countryName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      wrapHeaderText: true,
      valueFormatter: (params: any) => abbreviateCountryStr(params.data?.countryName),
    });
    colDef.push({
      ...defaultColumn,
      colId: 'SupplierName',
      headerName: 'Supplier',
      field: 'supplierName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      wrapHeaderText: true,
      resizable: false,
    });

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'Actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        suppressColumnsToolPanel: true,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showEdit: true,
          showCopy: true,
          showDelete: true,
          deleteData: (data: any, pathName: any) => {
            this.deleteConfirmation(data);
          },
          bookMarkComponent: (data: any) => {
            this.updateBookMark.next(data);
          },
          editData: (data: any, pathName: any) => {
            this.projectsFacade.openNewAddProjectMaterial(
              data.scenarioId,
              data.componentId,
              'Review component details',
              true,
              pathName
            );
          },
          copyData: (data: any, pathName: any) => {
            const lable = 'Copy material';
            this.copyPackMaterial.next([data, lable, data.scenarioId]);
          },
          copyDataEditRendarar: () => {
            return false;
          },
        },
        lockVisible: false,
        lockPosition: right,
        resizable: false,
      });
    return colDef;
  }
  getPackMaterialProjectListsCostDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: '',
        headerName: '',
        field: '',
        rowDrag: true,
        cellClass: 'scenarioDragIcon',
        minWidth: grid_widths_map.icon_md,
        maxWidth: grid_widths_map.icon_md,
        resizable: false,
      });
    colDef.push({
      ...defaultColumn,
      colId: '',
      headerName: '',
      field: '',
      cellClass: 'my-permission-cursor-pointer',
      maxWidth: grid_widths_map.icon_md,
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      autoHeaderHeight: true,
      wrapHeaderText: true,
      cellRenderer: 'bookmarkRenderer',
      cellRendererParams: {
        updateBookmark: (params: any) => {
          this.updateBookMark.next(params);
        },
      },
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Component name',
      field: 'name',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      cellStyle: { 'text-decoration': 'underline' },
      lockVisible: true,
      resizable: false,
      autoHeaderHeight: true,
      wrapHeaderText: true,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          this.projectsFacade.openNewAddProjectMaterial(
            params.data.scenarioId,
            params.data.componentId,
            'Review component details',
            true,
            'material-list'
          );
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'PackageLevelInfoName',
      headerName: 'Packaging levels',
      field: 'packageLevelInfoName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      autoHeaderHeight: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialWeight',
      headerName: 'Weight of component (grams)',
      field: 'materialWeight',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      autoHeaderHeight: true,
      wrapHeaderText: true,
      editable: this.accessPermission(),
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'MaterialWeight') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },

      cellRenderer: (params: any) => {
        return (
          '<span class="editable-icon editable-icon-padding-conversion">' +
          params.value +
          '<i class="fa fa-pencil icon-opacity" aria-hidden="true"></i></span>'
        );
      },
      cellEditorParams: {
        from: 'project-pages-inline',
        allowZero: 'true',
      },
      cellClass: ['outerGridEdit', 'outerGridProjectEdit', 'elipsisFields'],
      valueSetter: (params: any) => {
        const valueChanged = params.data[params.colDef.field] !== params.newValue;
        const oldValue = params.data[params.colDef.field];
        const newVal = params.newValue == 0 ? oldValue : params.newValue;
        if (params.newValue == 0) return;
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        const field = params.colDef.field;
        const nodeId = params.data.id;
        const inlineObject = {
          entityId: 'componentId',
          entityIdValue: params.data['componentId'],
          entityColumnName: params.colDef.field,
          filter: 'agTextColumnFilter',
          entityColumnValue: params.data[params.colDef.field],
        };
        if (!this.isEmpty(newVal) && valueChanged) {
          this.inlineEditing.next(inlineObject);
          return valueChanged;
        } else {
          this.toaster.error('Component name is required');
          return oldValue;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialName',
      headerName: 'Material',
      field: 'materialName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Convertions',
      headerName: 'Conversion',
      field: 'convertions',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      wrapHeaderText: true,
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
    });

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'Actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        suppressColumnsToolPanel: true,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showEdit: true,
          showCopy: true,
          showDelete: true,
          deleteData: (data: any, pathName: any) => {
            this.deleteConfirmation(data);
          },
          bookMarkComponent: (data: any) => {
            this.updateBookMark.next(data);
          },
          editData: (data: any, pathName: any) => {
            this.projectsFacade.openNewAddProjectMaterial(
              data.scenarioId,
              data.componentId,
              'Review component details',
              true,
              pathName
            );
          },
          copyData: (data: any, pathName: any) => {
            const lable = 'Copy material';
            this.copyPackMaterial.next([data, lable, data.scenarioId]);
          },
          copyDataEditRendarar: () => {
            return false;
          },
        },
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });
    return colDef;
  }
  costFormate(params: any) {
    // Format the value as desired
    const cost = (params.data.materialWeight / 100) * params.data.materialCost;
    return cost.toFixed(2);
  }

  getPackMaterialProjectPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getPackMaterialProjectListsDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.projectPackMaterialDataPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'Name',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  getTransportModalForManualLocationDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'OriginName',
      headerName: 'Location',
      field: 'originName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'PersanteageMassLoad',
      headerName: 'Load efficiency',
      field: 'persanteageMassLoad',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
      hide: true,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'Distance') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellEditorParams: {
        isCheckTransportDistance: true,
        from: 'project-pages-inline',
      },
      cellClass: ['outerGridEdit', 'outerGridProjectEdit', 'elipsisFields'],
      cellStyle: params => {
        const isCellEditable = params.rowIndex == 0 ? false : true;
        return {
          'pointer-events': isCellEditable ? '' : 'none',
        };
      },
      valueSetter: (params: any) => {
        const oldValue = params.data[params.colDef.field];
        const getDisType = oldValue.substring(oldValue.indexOf(' ') + 1);
        const newVal = params.newValue + ' ' + (getDisType == '0' ? ' ' : getDisType);
        const valueChanged = params.data[params.colDef.field] !== newVal;
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.projectsFacade.transportScenarioActions(params.data, 'edit');
          this.editProjectMaterialSub.next([params.data, false]);
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xs,
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'inlineActionButtonComponent',
      cellRendererParams: {
        // showDelete: true,
        // showEdit: true,
        showInlineEdit: true,
        showInlineDelete: true,
        from: 'projectPages',
        deleteInlineGrid: (data: any) => {
          this.alertConfirmation(data);
        },
        editDataInline: (data: any, pathName: any) => {
          this.projectsFacade.transportScenarioActions(data, 'edit');
          this.editProjectMaterialSub.next([data, true]);
        },
        saveDataInline: (data: any) => {
          this.saveProjectManualDistance.next([data, 'manualLocation']);
        },
        clearInputField: (data: any) => {
          this.clearInputFieldProjectManualDistance.next(data);
        },
      },
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      resizable: false,
    });
    return colDef;
  }

  getMaterialPackPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getTransportModalForManualLocationDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.projectPackMaterialDataPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'Name',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  getTransportModalForManualDestinationDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'PersanteageMassLoad',
      headerName: 'Load efficiency',
      field: 'persanteageMassLoad',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
      hide: true,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xs,
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'inlineActionButtonComponent',
      cellRendererParams: {
        showInlineEdit: true,
        showInlineDelete: true,
        from: 'projectPages',
        deleteInlineGrid: (data: any) => {
          this.alertConfirmationForDistance(data);
        },
        editDataInline: (data: any, pathName: any) => {
          this.projectsFacade.transportScenarioActionsFordistance(data, 'edit');
          this.editProjectMaterialManualDistanceSub.next(data);
        },
        saveDataInline: (data: any) => {
          this.saveProjectManualDistance.next([data, 'manualDistance']);
        },
        clearInputField: (data: any) => {
          this.clearInputFieldProjectManualDistance.next(data);
        },
      },
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      resizable: false,
    });
    return colDef;
  }
  getMaterialPackPayloadForDestination(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getTransportModalForManualDestinationDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.projectPackConversionProcessDataPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'Name',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  getConversionProcessDataColumn(isAreaBaseConversionProcess?: any): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'isAreaBaseConversionProcess',
      field: 'isAreaBaseConversionProcess',
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ConversionProcessName',
      headerName: 'Conversion process',
      field: 'conversionProcessName',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'gridCellInfoComponent',
      // sort: 'desc',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ConversionCost',
      headerName: 'Cost of conversion per kg',
      field: 'conversionCost',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'ConversionCost') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellRenderer: (params: any) => {
        const value = params.value ? params.value : 0;
        return (
          '<span class="editable-icon editable-icon-padding-conversion">' +
          value +
          '<i class="fa fa-pencil icon-opacity" aria-hidden="true"></i></span>'
        );
      },
      cellEditorParams: {
        from: 'project-pages-inline',
      },
      cellClass: ['outerGridEdit', 'outerGridProjectEdit', 'elipsisFields'],
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.projectsFacade.packMaterialConversionProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      // sort: 'desc',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ConversionCountryName',
      headerName: 'Country',
      field: 'conversionCountryName',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'newProjectInlineDropdownComponent',
      cellRendererParams: {
        type: 'packMatrialConversion',
        editData: (data: any) => {
          this.projectsFacade.packMaterialConversionProcess(data, 'edit');
        },
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'AreaBaseConversionProcess',
      headerName: 'Area',
      field: 'areaBaseConversionProcess',
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'AreaBaseConversionProcess') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },

      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.projectsFacade.packMaterialConversionProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      // sort: 'desc',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ConversionSupplierName',
      headerName: 'Converter',
      field: 'conversionSupplierName',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'gridProjectAutocompleteComponent',
      cellRendererParams: {
        editData: (data: any) => {
          this.projectsFacade.packMaterialConversionProcess(data, 'edit');
        },
      },
      // sort: 'desc',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xs,
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        showDelete: true,
        deleteData: (data: any) => {
          this.alertConfirmationForConversion(data);
        },
      },
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      resizable: false,
    });
    return colDef;
  }

  getCustomTransportItemsList(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'CityName',
      headerName: 'Origin-destination',
      field: 'cityName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    return colDef;
  }

  alertConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectsFacade.projectPackMaterialTransportScenarioList$
          .pipe(take(1))
          .subscribe((records: any) => {
            this.allTransportLocationRecords = records;
          });
        this.projectsFacade.transportScenarioActions(data, 'delete');
        this.checkDeleteRow.next([this.allTransportLocationRecords, data, true]);
      }
    });
  }
  alertConfirmationForDistance(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectsFacade.transportScenarioActionsFordistance(data, 'delete');
        this.checkDeleteRow.next([undefined, data, false]);
      }
    });
  }

  alertConfirmationForConversion(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectsFacade.packMaterialConversionProcess(data, 'delete');
        this.areaHideShowCheck.next('');
      }
    });
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deletePackMaterial.next([data]);
      }
    });
  }

  isEmpty(val: any) {
    val = val.toString();
    if (val !== undefined || val !== null || val !== '') {
      val = val?.trim();
    }
    return val === undefined || val === null || val === '';
  }

  getPackMaterialList() {
    this.editFillingSuccess.next(() => {});
  }

  accessPermission(): boolean {
    return this.accessService.hasPermission('edit', '', 'packaging');
  }
}
